import { Table, Row, Col, Form, Modal } from "react-bootstrap";
import { UserDataContext } from "../components/UserDataContext";
import { useState, useEffect, useContext } from "react";
import "../components/button.css";
import { marginBottom } from "../App";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import Pagination from "@mui/material/Pagination";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import Alerts from "../components/Alerts";
import { apiRequest } from "../components/Config";

export default function PerformersData({ taskId, refreshData }) {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [searchMode, setSearchMode] = useState(false);
  const [performer, setPerformer] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [text, setText] = useState("Pobieranie danych...");
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [apiResponse, setApiResponse] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      if (!userData || !userData.userId) return;
      try {
        const response = await apiRequest("users/2", "GET");
        setData(response);
      } catch (error) {
        console.error("Błąd pobierania danych", error);
      }
    };
    fetchData();
  }, [userData]);

  useEffect(() => {
    if (!userData) return;
    const fetchData = async () => {
      try {
        const response = await apiRequest(`search/2`, "POST", {
          param: searchValue,
        });
        setData(response);
        if (response.length === 0)
          setText("Brak danych spełniających kryteria wyszukiwania...");
      } catch (error) {
        console.error("Błąd wyszukiwania", error);
      }
    };
    fetchData();
  }, [searchMode, userData, searchValue]);

  const handleCheckboxChange = (id, fullname) => {
    if (selectedId === id) {
      setSelectedId(null);
      setPerformer(null);
    } else {
      setSelectedId(id);
      setPerformer(fullname);
    }
  };

  const sortedData = [...data].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const direction = sortConfig.direction === "asc" ? 1 : -1;
    return a[sortConfig.key] < b[sortConfig.key]
      ? -1 * direction
      : a[sortConfig.key] > b[sortConfig.key]
      ? 1 * direction
      : 0;
  });

  const paginatedData = sortedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleChangePage = (event, page) => setCurrentPage(page);

  const requestSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    setSearchMode(e.target.value.length > 0);
  };

  const handleClose = () => setShow(false);

  const handleShow = () => {
    if (selectedId) setShow(true);
  };

  const handleConfirm = async () => {
    //console.log("Potwierdzono dla ID:", selectedId, taskId);
    setShow(false);

    try {
      const response = await apiRequest("taskuser", "POST", {
        taskId: taskId,
        performer: selectedId,
      });
      //      console.log("Odpowiedź z serwera:", response);
      if (response.error_msg === 200) {
        setApiResponse({
          title: "Informacja",
          severity: "success",
          info: "Zlecenie przekazane do Wykonawcy.",
        });
        setShowApiResponse(true);
        refreshData();
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania żądania:", error);
    }
  };

  return (
    <div>
      {showApiResponse && (
        <Row style={{ marginBottom }}>
          <Alerts data={apiResponse} />
        </Row>
      )}
      {/* MODAL */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Potwierdzenie</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Czy na pewno chcesz przydzielić zlecenie ID: [{taskId}] <br />
          Wykonawcy: <b>{performer}?</b>
          <br />
          Na wskazany przy Wykonawcy email zostanie wysłany mail z
          powiadomieniem.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outlined" onClick={handleClose}>
            Anuluj
          </Button>
          <Button variant="contained" onClick={handleConfirm}>
            Potwierdź
          </Button>
        </Modal.Footer>
      </Modal>

      <ThemeProvider theme={theme}>
        <Row style={{ marginBottom }}>
          <Col xs={4} sm={3}>
            <TextField
              label="Wyszukaj Wykonawcę"
              variant="outlined"
              onChange={handleSearch}
              fullWidth
            />
          </Col>
          <Col xs={4} sm={6}>
            <Pagination
              count={Math.ceil(data.length / itemsPerPage)}
              page={currentPage}
              onChange={handleChangePage}
              color="primary"
              variant="outlined"
              shape="rounded"
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <p className="p1">Wybierz wykonawcę zlecenia ID: [{taskId}]</p>
          </Col>
          <Col>
            <p className="p2">{performer}</p>
          </Col>
          <Col>
            {selectedId && (
              <Button variant="outlined" onClick={handleShow}>
                Przydziel zlecenie
              </Button>
            )}
          </Col>
        </Row>

        {/* TABELA */}
        <div className="table-responsive">
          <Table bordered hover>
            <thead>
              <tr>
                <th className="td-centered">#</th>
                <th className="td-centered" onClick={() => requestSort("id")}>
                  ID
                </th>
                <th onClick={() => requestSort("fullName")}>Wykonawca</th>
                <th onClick={() => requestSort("permbuild")}>Upr. budowlane</th>
                <th onClick={() => requestSort("cnt2")}>Lb. zleceń br.</th>
                <th onClick={() => requestSort("expertise")}>Rzeczoznawstwo</th>
              </tr>
            </thead>
            {data.length > 0 && userData.userId ? (
              <tbody>
                {paginatedData.map((item, index) => (
                  <tr key={item.id}>
                    <td className="td-centered">
                      <Form.Check
                        type="checkbox"
                        checked={selectedId === item.id}
                        onChange={() =>
                          handleCheckboxChange(item.id, item.fullName)
                        }
                      />
                    </td>
                    <td className="td-centered">
                      {(currentPage - 1) * itemsPerPage + index + 1}
                    </td>
                    <td>{item.fullName}</td>
                    <td className="td-centered">{item.permbuild}</td>
                    <td className="td-centered">{item.cnt2}</td>
                    <td className="td-centered">{item.expertise}</td>
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan="5" style={{ textAlign: "center" }}>
                    <h6>{text}</h6>
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
        </div>
      </ThemeProvider>
    </div>
  );
}
